import { MasterConfigContext } from "@/context/MasterConfigContext";
import { useContext } from "react";
const scheduleData = [
  {
    "state_en": "West Bengal",
    "state_hi": "पश्चिम बंगाल",
    "phases": [
      {
        "phase": "पहला चरण",
        "seats": 152,
        "notification": "30-03-2026",
        "nomination_last_date": "06-04-2026",
        "scrutiny_last_date": "07-04-2026",
        "withdrawal_last_date": "09-04-2026",
        "polling": "23-04-2026",
        "counting": "04-05-2026"
      },
      {
        "phase": "दूसरा चरण",
        "seats": 142,
        "notification": "02-04-2026",
        "nomination_last_date": "09-04-2026",
        "scrutiny_last_date": "10-04-2026",
        "withdrawal_last_date": "13-04-2026",
        "polling": "29-04-2026",
        "counting": "04-05-2026"
      }
    ]
  },
  {
    "state_en": "Tamil Nadu",
    "state_hi": "तमिलनाडु",
    "phases": [
      {
        "phase": "पहला चरण",
        "seats": 234,
        "notification": "30-03-2026",
        "nomination_last_date": "06-04-2026",
        "scrutiny_last_date": "07-04-2026",
        "withdrawal_last_date": "09-04-2026",
        "polling": "23-04-2026",
        "counting": "04-05-2026"
      }
    ]
  },
  {
    "state_en": "Kerala",
    "state_hi": "केरल",
    "phases": [
      {
        "phase": "पहला चरण",
        "seats": 140,
        "notification": "16-03-2026",
        "nomination_last_date": "23-03-2026",
        "scrutiny_last_date": "24-03-2026",
        "withdrawal_last_date": "26-03-2026",
        "polling": "09-04-2026",
        "counting": "04-05-2026"
      }
    ]
  },
  {
    "state_en": "Assam",
    "state_hi": "असम",
    "phases": [
      {
        "phase": "पहला चरण",
        "seats": 126,
        "notification": "16-03-2026",
        "nomination_last_date": "23-03-2026",
        "scrutiny_last_date": "24-03-2026",
        "withdrawal_last_date": "26-03-2026",
        "polling": "09-04-2026",
        "counting": "04-05-2026"
      }
    ]
  },
  {
    "state_en": "Puducherry",
    "state_hi": "पुदुचेरी",
    "phases": [
      {
        "phase": "पहला चरण",
        "seats": 30,
        "notification": "16-03-2026",
        "nomination_last_date": "23-03-2026",
        "scrutiny_last_date": "24-03-2026",
        "withdrawal_last_date": "26-03-2026",
        "polling": "09-04-2026",
        "counting": "04-05-2026"
      }
    ]
  }
]
const FiveElectionSchedule = ({ state, state_en }) => {
  const masterconfig = useContext(MasterConfigContext);
  const widgetKey = masterconfig?.["assembly_widgets_2026"]?.["scheduleFrame"];
  if (!widgetKey || !state) {
    return null;
  }
  const scheduleHtml = () => {
    return widgetKey[state];
  };
  const scheduleUrl = scheduleHtml()

  return (
    <div className="w-full my-4 ">

      <div className="space-y-10">
        {scheduleData?.filter((s) => s.state_en === state_en).map((state, index) => (

          <div key={index} className="overflow-x-auto w-full whitespace-nowrap md:whitespace-normal">
            <table className="w-full">
              <thead>
                <tr className="bg-primary text-white">
                  <th className="p-2 border border-black">चरण</th>
                  <th className="p-2 border border-black">सीटें</th>
                  <th className="p-2 border border-black">नोटिफिकेशन</th>
                  <th className="p-2 border border-black">नॉमिनेशन की अंतिम तारीख</th>
                  <th className="p-2 border border-black">नॉमिनेशन की जांच की अंतिम तारीख</th>
                  <th className="p-2 border border-black">नामांकन वापस लेने की अंतिम तारीख</th>
                  <th className="p-2 border border-black">मतदान</th>
                  <th className="p-2 border border-black">वोटों की गिनती</th>
                </tr>
              </thead>

              <tbody>
                {state.phases.map((phase, i) => (
                  <tr key={i}>
                    <td className="p-2 border border-black">{phase.phase}</td>
                    <td className="p-2 border border-black">{phase.seats}</td>
                    <td className="p-2 border border-black">{phase.notification}</td>
                    <td className="p-2 border border-black">{phase.nomination_last_date}</td>
                    <td className="p-2 border border-black">{phase.scrutiny_last_date}</td>
                    <td className="p-2 border border-black">{phase.withdrawal_last_date}</td>
                    <td className="p-2 border border-black">{phase.polling}</td>
                    <td className="p-2 border border-black">{phase.counting}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

        ))}
      </div>

      <iframe
        src={scheduleUrl}
        style={{ width: '100%', height: '100vh', overflow: 'hidden' }}
        className="scrollbar-none my-4"
        title="Election Schedule"
      >
      </iframe>
    </div>
  );
};

export default FiveElectionSchedule;
